import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AppDataService } from 'modules/golf/legacy/shared/services/app-data.service';
import { LegacyGolfInitializerService } from 'modules/golf/legacy/shared/services/legacy-golf-app-initializer.service';
// import { CommondataService } from 'modules/onecart/projects/shared/services/commondata.service';
// import { OnecartAppInitializerService } from 'modules/onecart/services/onecart-app-initializer.service';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { HttpService } from 'modules/shared/services/http.service';
import { SpaAppDataService } from 'modules/spa/legacy/shared/services/spa-app-data.service';
import { SpaAppInitializerService } from 'modules/spa/legacy/shared/services/spa-app-initializer.service';
import { forkJoin, tap, timeout } from 'rxjs';
import { environment } from 'environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  azureBlobTokenKey: string = '';
  public admin_service = '/wbe-admin-service/';
  public cloudBackendDomain: string = environment.backendApiUrl;
  constructor(
    // public onecartAppInitService: OnecartAppInitializerService,
    public legacyBookInitService: LegacyBookInitService,
    public legacyGolfInitService: LegacyGolfInitializerService,
    public legacySpaInitService: SpaAppInitializerService,
    public legacyGolfAppDataService: AppDataService,
    public legacySpaAppDataService: SpaAppDataService,
    public injector: Injector,
    public http: HttpService,
    public httpClient: HttpClient // public commonData: CommondataService
  ) {}

  injectCssFromUrl(url: string, styleTagId: string) {
    this.httpClient
      .get(url, { responseType: 'text' })
      .toPromise()
      .then(async (val: any) => {
        const head = document.head || document.getElementsByTagName('head')[0];
        let styleTag;
        styleTag = document.createElement('style');
        styleTag.type = 'text/css';
        styleTag.id = styleTagId;
        styleTag.textContent = val;
        head.appendChild(styleTag);
      });
  }

  injectCssForBook() {
    this.httpClient
      .get('./assets/css/material.indigo-pink.min.css', {
        responseType: 'text',
      })
      .toPromise()
      .then(async (val: any) => {
        const head = document.head || document.getElementsByTagName('head')[0];
        let styleTag;
        styleTag = document.createElement('style');
        styleTag.type = 'text/css';
        styleTag.id = 'material.indigo-pink';
        styleTag.textContent = val;
        head.appendChild(styleTag);
        this.injectCssFromUrl('./assets/book-global.scss', 'book-global-cloudTheme');
      })
      .catch(() => {
        this.injectCssFromUrl('./assets/book-global.scss', 'book-global-cloudTheme');
      });
  }

  async getAzureBlobToken() {
    if (environment.proxy) {
      this.http.proxy = environment.proxy;
      this.cloudBackendDomain = environment.backendApiUrl;
    } else {
      let hostName = document.location.hostname;
      this.cloudBackendDomain = window.location.protocol + '//' + hostName;
    }

    let azureBlobToken = window['__env']['azureBlobTokenKey'];
    if (azureBlobToken) {
      if (!this.azureBlobTokenKey) {
        setInterval(() => {
          this.getAzureBlobToken();
        }, 55 * 60 * 1000);
      }
      window['__env']['azureBlobTokenKey'] = '';
      this.azureBlobTokenKey = azureBlobToken;
    } else {
      let url = this.cloudBackendDomain + this.admin_service + 'generateAzureBlobStorageSAS';
      await this.http
        .get(url)
        .toPromise()
        .then((res) => {
          console.log(res);
          if (res && res.success) {
            if (!this.azureBlobTokenKey) {
              setInterval(() => {
                this.getAzureBlobToken();
              }, 55 * 60 * 1000);
            }
            this.azureBlobTokenKey = res.token;
          }
        })
        .catch((e) => {
          // if (!this.azureBlobTokenKey) this.commonData.maintenaceStatus.common = true;
        });
    }
  }

  validateVanityUrl() {
    const pathData = location.pathname.split('/');
    const browserUrl = window.location.protocol + '//' + document.location.hostname;
    const tenantId = pathData[3];
    const propertyId = pathData[4];
    const validateVanityUrl = `${browserUrl}/wbe-property-service/commonProperty/tenants/${tenantId}/propertyId/${propertyId}/validateVanityUrl`;
    const data = { vanityUrl: browserUrl };
    return this.http.post(validateVanityUrl, data);
  }

  load() {
    return new Promise(async (resolve, reject) => {
      let pathData = location.pathname.split('/');
      let appName = pathData[1];
      this.http.appName = appName;
      let isValidTenant = true;
      const browserUrl = window.location.protocol + '//' + document.location.hostname;
      const backendApiUrls = environment.backendApiUrl.split(',');
      const expressBackendApiUrls = environment.expressBackendApiUrl.split(',');
      if (!environment.proxy && !backendApiUrls.includes(browserUrl) && !expressBackendApiUrls.includes(browserUrl)) {
        let vanityResponse = await this.validateVanityUrl().toPromise();
        if (vanityResponse?.success && vanityResponse.isValidUrl) {
          isValidTenant = true;
        } else {
          isValidTenant = false;
        }
      }
      if (isValidTenant) {
        await this.getAzureBlobToken();
        switch (appName) {
          case 'wbe':
          case 'cico':
            if (pathData[2] == 'group') {
              this.injectCssFromUrl('./assets/group-global.scss', 'group-global-cloudTheme');
              this.injectCssForBook();
            } else if (appName === 'wbe') {
              this.injectCssForBook();
            } else {
              this.injectCssFromUrl('./assets/css/material.indigo-pink.min.css', 'material.indigo-pink');
              this.injectCssFromUrl('./assets/cico_global.scss', 'cico-global-cloudTheme');
            }
            let wbecicoResolveData = this.legacyBookInitService.load(this.azureBlobTokenKey).then((res) => {
              var router: Router = this.injector.get(Router);
              if (location.pathname != '/') {
                let pathData = location.pathname.split('/');
                if (pathData[1] == 'wbe') $('body').css('overflow', 'unset');
                if (!this.legacyBookInitService.tenantFound) {
                  var router: Router = this.injector.get(Router);

                  if (pathData[1] == 'wbe' || pathData[2] == 'wbe') {
                    router.navigate(['/404']);
                  } else if (pathData[1] == 'cico' || pathData[2] == 'cico') {
                    router.navigate(['/cico/error']);
                  }
                } else {
                  let maintenanceFlag = this.legacyBookInitService?.PropertyData?.UrlMap?.MaintenaceStatus;
                  console.log(maintenanceFlag + ' ' + this.legacyBookInitService.tenantId + ' ' + this.legacyBookInitService.propertyId);
                  if (maintenanceFlag == 'true' || maintenanceFlag == true) {
                    if (pathData[1] == 'wbe' || pathData[2] == 'wbe') {
                      router.navigate([
                        '/wbe/maintenance/' + this.legacyBookInitService.tenantId + '/' + this.legacyBookInitService.propertyId,
                      ]);
                    } else {
                      router.navigate([
                        '/cico/maintenance/' + this.legacyBookInitService.tenantId + '/' + this.legacyBookInitService.propertyId,
                      ]);
                    }
                  }
                }

                if (
                  localStorage.getItem(
                    'ng2Idle.' + this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '.expiry'
                  )
                ) {
                  let time = JSON.parse(
                    localStorage.getItem(
                      'ng2Idle.' + this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '.expiry'
                    )
                  );
                  let now = new Date().getTime();
                  if (now > time) {
                    let GuestLayout;
                    let cart;
                    if (
                      typeof localStorage.getItem(
                        this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'GuestLayout'
                      ) != 'undefined' &&
                      JSON.parse(
                        localStorage.getItem(
                          this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'GuestLayout'
                        )
                      ) != null
                    ) {
                      GuestLayout = JSON.parse(
                        localStorage.getItem(
                          this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-GuestLayout'
                        )
                      );
                      for (let d = 0; d < GuestLayout.length; d++) {
                        for (let e = 0; e < GuestLayout[d].guestDetails.length; e++) {
                          if (GuestLayout[d].guestDetails[e].isCasinoPlayer) {
                            GuestLayout[d].guestDetails[e].Authorized = false;
                          }
                        }
                      }
                      console.log('Authorization Fialure,Relogin Required: ', GuestLayout);
                      localStorage.setItem(
                        this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-GuestLayout',
                        JSON.stringify(GuestLayout)
                      );
                    }
                    if (
                      typeof localStorage.getItem(
                        this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'cart'
                      ) != 'undefined' &&
                      JSON.parse(
                        localStorage.getItem(
                          this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'cart'
                        )
                      ) != null
                    ) {
                      cart = JSON.parse(
                        localStorage.getItem(this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-cart')
                      );
                      for (let d = 0; d < cart.length; d++) {
                        for (let e = 0; e < cart[d].guestDetails.length; e++) {
                          if (cart[d].guestDetails[e].isCasinoPlayer) {
                            cart[d].guestDetails[e].Authorized = false;
                          }
                        }
                      }
                      localStorage.setItem(
                        this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-cart',
                        JSON.stringify(cart)
                      );
                    }

                    let casinoMapDate = [];
                    if (
                      typeof localStorage.getItem(
                        this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'userLoggedIn'
                      ) != 'undefined' &&
                      JSON.parse(
                        localStorage.getItem(
                          this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'userLoggedIn'
                        )
                      ) != null
                    ) {
                      let loginPlayer = JSON.parse(
                        localStorage.getItem(
                          this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'userLoggedIn'
                        )
                      );
                      casinoMapDate.push(loginPlayer);
                    }
                    if (
                      typeof localStorage.getItem(
                        this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'casinoPlayerToken'
                      ) != 'undefined' &&
                      JSON.parse(
                        localStorage.getItem(
                          this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'casinoPlayerToken'
                        )
                      ) != null
                    ) {
                      let secondaryPlayer = JSON.parse(
                        localStorage.getItem(
                          this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'casinoPlayerToken'
                        )
                      );
                      casinoMapDate = casinoMapDate.concat(secondaryPlayer);
                    }

                    console.log('Casino details needs to be deleted are as follows:' + casinoMapDate);
                    localStorage.removeItem(
                      this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'casinoPlayerToken'
                    );
                    localStorage.removeItem(
                      this.legacyBookInitService.tenantId + '-' + this.legacyBookInitService.propertyId + '-' + 'userLoggedIn'
                    );
                    if (casinoMapDate.length > 0) {
                      let observables = [];
                      var _http: HttpClient = this.injector.get(HttpClient);
                      let serviceName = this.legacyBookInitService.getcasioToken_server_name();
                      let tenantId = this.legacyBookInitService.tenantId;
                      let propertyId = this.legacyBookInitService.propertyId;
                      let functionName = this.legacyBookInitService.casinoTokenDeleteFunction;
                      let propertyName = this.legacyBookInitService?.PropertyData?.PropNameKeyList?.validCasino;
                      let URL = [];
                      for (let i = 0; i < casinoMapDate.length; i++) {
                        URL[i] =
                          this.legacyBookInitService.getCloudDomainName() +
                          '/' +
                          serviceName +
                          '/tenants/' +
                          tenantId +
                          ('/context/' + this.legacyBookInitService?.PropertyData?.ContextId + '/') +
                          'propertyName/' +
                          propertyName +
                          '/casinoNo/' +
                          casinoMapDate[i].casinoNumber +
                          '/token/' +
                          casinoMapDate[i].token +
                          '/' +
                          functionName;
                        observables.push(
                          _http.delete(URL[i], this.legacyBookInitService.serviceHeaders).pipe(tap((data) => console.log(data)))
                        );
                      }
                      forkJoin(observables).subscribe((res) => {
                        console.log('Casino Details deleted', res);
                      });
                    }
                  }
                }
              } else {
                router.navigate(['/404']);
              }
            });
            resolve(wbecicoResolveData);
            break;
          case 'admin':
            if (!environment.proxy) {
              const browserUrl = window.location.protocol + '//' + document.location.hostname;
              environment.backendApiUrl = browserUrl;
              environment.expressBackendApiUrl = browserUrl;
            }
            resolve(true);
            break;
          case 'spa':
            this.injectCssFromUrl('./assets/spa_global.scss', 'spa-global-theme');
            let wbeSpaResolveData = this.legacySpaInitService.initializeApp(this.azureBlobTokenKey).then((data) => {
              var router: Router = this.injector.get(Router);
              if (!this.legacySpaInitService.tenantFound || !this.legacySpaAppDataService.tenantFound) {
                router.navigate(['/spa/maintenance/' + this.legacySpaInitService.tenantId + '/' + this.legacySpaInitService.propertyId]);
              }
            });
            resolve(wbeSpaResolveData);
            break;
          case 'golf':
            this.injectCssFromUrl('./assets/golf_global.scss', 'golf-global-cloudTheme');
            let wbeGolfResolveData = this.legacyGolfInitService.initializeApp(this.azureBlobTokenKey).then((data) => {
              var router: Router = this.injector.get(Router);
              if (!this.legacyGolfInitService.tenantFound || !this.legacyGolfAppDataService.tenantFound) {
                router.navigate(['/golf/maintenance/' + this.legacyGolfInitService.tenantId + '/' + this.legacyGolfInitService.propertyId]);
              }
            });
            resolve(wbeGolfResolveData);
            break;
          case 'accessRestricted':
            let routers: Router = this.injector.get(Router);
            routers.navigate(['/accessRestricted/' + pathData[2] + '/' + pathData[3]]);
            resolve(true);
            break;
          default:
            let router: Router = this.injector.get(Router);
            router.navigate(['/404']);
            resolve(true);
        }
      } else {
        let router: Router = this.injector.get(Router);
        router.navigate(['/404']);
        resolve(true);
      }
    });
  }
}
